import type { SealedProduct } from "@hobbyshopify/backend-client";

/** A Sealed save threw on its way: it may have gone through, so the list is read again. */
export const SEALED_SAVE_FAILED_ON_THE_WAY = "Something went wrong while saving. Check the list before trying again.";

/** Whether buyers can cart the product without a scan, and why not when they cannot. Null once archived. */
export function publicOfferBadge(
  product: Pick<SealedProduct, "status" | "publicOffer" | "trackStock" | "marketValueCents" | "available">,
): { label: string; onSale: boolean } | null {
  if (product.status === "ARCHIVED") return null;
  if (product.publicOffer && product.available > 0) return { label: "On sale", onSale: true };
  if (product.publicOffer) return { label: "Not on sale: out of stock", onSale: false };
  if (!product.trackStock) return { label: "Not on sale: stock not counted", onSale: false };
  if (product.marketValueCents == null) return { label: "Not on sale: no price", onSale: false };
  return { label: "Not on sale", onSale: false };
}
